import { useNavigate } from 'react-router-dom';

import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import LaunchIcon from '@mui/icons-material/Launch';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

import './ProviderTableRow.scss';
import { formatProviderName, getProviderUrl } from '../../helpers/providers';
import { MAX_WITH_MOBILE_MEDIA } from '../../config/getTheme';
import ScheduleWithProviderButton from '../booking/ScheduleWithProviderButton';

const ProviderTableRow = props => {
  const { provider: p } = props;
  const navigate = useNavigate();

  return (
    <Stack
      flexDirection='row'
      justifyContent='space-between'
      padding={0.5}
      className='ProviderTableRow'
      // onClick={() => navigate(getProviderUrl(p))}
    >
      <Stack flexDirection='row' className='ProviderItem__avatar-text'>
        <Avatar
          className='ProviderItem__avatar'
          variant="square"
          src={p.imgSrc || p.public_profile_img_url}
          alt={`${p.firstName} ${p.lastName}`}
        />
        <Stack
          justifyContent='space-between'
          padding={0.5}
        >
          <Button
            size='small'
            endIcon={<LaunchIcon />}
            style={{ fontWeight: 'bold'}}
            onClick={() => navigate(getProviderUrl(p))}
          >
            {formatProviderName(p)}
          </Button>
          <Typography
            variant='normal'
            color='text.light'
            sx={{
              paddingLeft: '0.45rem',
              lineHeight: 'normal',
              overflow: "hidden",
              textOverflow: "ellipsis",
              WebkitLineClamp: "1",
              WebkitBoxOrient: "vertical",
              display: "-webkit-box",
            }}
          >
            {p.city}{p.state ? `, ${p.state}` : ''}
          </Typography>
        </Stack>
      </Stack>

      <Stack
        className='ProviderItem__button-stack'
        direction={{ xs: 'column', sm: 'row' }}
        alignItems='center'
        justifyContent='center'
      >
        {/* <Button
          variant='primaryOutline'
          size='small'
          sx={{
            whiteSpace: 'nowrap'
          }}
          onClick={(e) => {
            e.stopPropagation();
            navigate(`/clients/messages/${p.id}`); // FIXME
          }}
        >
          <Typography
            variant='small'
            color='text.blue'
            sx={{
              [MAX_WITH_MOBILE_MEDIA]: {
                fontSize: '0.6875rem',
              },
            }}
          >
            Send Message
          </Typography>
        </Button> */}
        {/* <Button
          variant='primaryOutline'
          size='small'
          sx={{
            whiteSpace: 'nowrap'
          }}
          onClick={(e) => {
            e.stopPropagation();
            navigate(`/clients/appointments/new/${p.id}`);
          }}
        >
          <Typography
            variant='small'
            color='text.blue'
            sx={{
              [MAX_WITH_MOBILE_MEDIA]: {
                fontSize: '0.6875rem',
              },
            }}
          >
            Schedule Now
          </Typography>
        </Button> */}
        <Button
          variant='contained'
          size='small'
          onClick={(e) => {
            e.stopPropagation();
            navigate(`/clients/messages/${p.id}`); // FIXME
          }}
        >
          Send Message
        </Button>
        {/* <ScheduleWithProviderButton
          provider={p}
          size='small'
        /> */}
        <Button
          variant='contained'
          size='small'
          onClick={(e) => {
            e.stopPropagation();
            navigate(`/clients/booking?providerId=${p.id}`);
          }}
        >
          Schedule
        </Button>
      </Stack>
    </Stack>
  );
};

export default ProviderTableRow;
